export const startAt = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMediumMaxWidth,
});
